var handleAverageMarker, handleCentre, handleMarkers, handlePlaces, m,
  slice = [].slice;

m = require('mithril');

handleCentre = function(ctrl, args, el, isInitialized, context) {
  return context.map.setCenter(args.centre());
};

handleMarkers = function(ctrl, args, el, isInitialized, context) {
  var add, i, j, len, len1, marker, pin, ref, ref1, remove, results, update;
  add = function(marker) {
    var info, pin;
    pin = new google.maps.Marker({
      title: marker.name,
      label: marker.name[0],
      position: marker.position,
      map: context.map,
      draggable: true,
      animation: google.maps.Animation.DROP
    });
    pin.marker = marker;
    context.pins.push(pin);
    info = new google.maps.InfoWindow({
      content: marker.name
    });
    pin.addListener('click', function() {
      return info.open(context.map, pin);
    });
    return pin.addListener('dragend', function() {
      return args.onMarkerMoved(marker, pin.getPosition().toJSON());
    });
  };
  update = function(pin, marker) {
    pin.setTitle(marker.name);
    return pin.setPosition(marker.position);
  };
  remove = function(pin) {
    var p;
    pin.setMap(null);
    return context.pins = (function() {
      var i, len, ref, results;
      ref = context.pins;
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        p = ref[i];
        if (p !== pin) {
          results.push(p);
        }
      }
      return results;
    })();
  };
  ref = context.pins;
  for (i = 0, len = ref.length; i < len; i++) {
    pin = ref[i];
    marker = ((function() {
      var j, len1, ref1, results;
      ref1 = args.markers();
      results = [];
      for (j = 0, len1 = ref1.length; j < len1; j++) {
        marker = ref1[j];
        if (pin.marker.id === marker.id) {
          results.push(marker);
        }
      }
      return results;
    })())[0];
    if (marker == null) {
      remove(pin);
    }
  }
  ref1 = args.markers();
  results = [];
  for (j = 0, len1 = ref1.length; j < len1; j++) {
    marker = ref1[j];
    pin = ((function() {
      var k, len2, ref2, results1;
      ref2 = context.pins;
      results1 = [];
      for (k = 0, len2 = ref2.length; k < len2; k++) {
        pin = ref2[k];
        if (pin.marker.id === marker.id) {
          results1.push(pin);
        }
      }
      return results1;
    })())[0];
    if (pin != null) {
      results.push(update(pin, marker));
    } else {
      results.push(add(marker));
    }
  }
  return results;
};

handleAverageMarker = function(ctrl, args, el, isInitialized, context) {
  var add, average, remove, update;
  remove = function() {
    if (context.averagePin !== null) {
      context.averagePin.setMap(null);
      return context.averagePin = null;
    }
  };
  add = function(average) {
    var info, pin;
    pin = new google.maps.Marker({
      title: 'THE CENTRE!',
      position: average,
      map: context.map,
      animation: google.maps.Animation.BOUNCE,
      zIndex: 0,
      icon: 'imgs/blue_MarkerX.png'
    });
    context.averagePin = pin;
    info = new google.maps.InfoWindow({
      content: 'This is the weighted average of all the markers.'
    });
    return pin.addListener('click', function() {
      return info.open(context.map, pin);
    });
  };
  update = function(average) {
    return context.averagePin.setPosition(average);
  };
  average = args.average();
  if (average === null) {
    return remove();
  } else {
    if (context.averagePin) {
      return update(average);
    } else {
      return add(average);
    }
  }
};

handlePlaces = function(ctrl, args, el, isInitialized, context) {
  var add, i, j, len, len1, pin, place, ref, ref1, remove, results;
  add = function(place) {
    var info, pin;
    console.log('add', place);
    pin = new google.maps.Marker({
      title: place.name,
      position: place.geometry.location,
      icon: {
        url: place.icon,
        scaledSize: {
          width: 18,
          height: 18
        }
      },
      map: context.map,
      opacity: 0.9
    });
    context.placePins.push(pin);
    info = new google.maps.InfoWindow({
      content: place.name
    });
    return pin.addListener('click', function() {
      return info.open(context.map, pin);
    });
  };
  remove = function(pin) {
    var p;
    pin.setMap(null);
    return context.placePins = (function() {
      var i, len, ref, results;
      ref = context.placePins;
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        p = ref[i];
        if (p !== pin) {
          results.push(p);
        }
      }
      return results;
    })();
  };
  ref = context.placePins;
  for (i = 0, len = ref.length; i < len; i++) {
    pin = ref[i];
    remove(pin);
  }
  ref1 = args.places();
  results = [];
  for (j = 0, len1 = ref1.length; j < len1; j++) {
    place = ref1[j];
    results.push(add(place));
  }
  return results;
};

module.exports = {
  view: function(ctrl, args) {
    var mapConfig;
    mapConfig = function(el, isInitialized, context) {
      var map;
      if (!args.apiLoaded()) {
        el.innerHTML = 'Loading map. Please wait...';
        return;
      }
      if (context.map == null) {
        console.log('Creating map');
        map = new google.maps.Map(el, {
          zoom: 9,
          center: args.centre()
        });
        map.addListener('dragend', function() {
          return args.onCentreChanged(map.getCenter().toJSON());
        });
        context.map = map;
        context.pins = [];
        context.placePins = [];
        context.averagePin = null;
        context.onunload = function() {
          var i, len, pin, ref;
          ref = context.pins;
          for (i = 0, len = ref.length; i < len; i++) {
            pin = ref[i];
            pin.setMap(null);
          }
          context.map = null;
          context.pins = null;
          return context.averagePin = null;
        };
      }
      console.log('Updating map');
      handleCentre.apply(null, [ctrl, args].concat(slice.call(arguments)));
      handleMarkers.apply(null, [ctrl, args].concat(slice.call(arguments)));
      handleAverageMarker.apply(null, [ctrl, args].concat(slice.call(arguments)));
      return handlePlaces.apply(null, [ctrl, args].concat(slice.call(arguments)));
    };
    return m('.markermap', {
      config: mapConfig
    });
  }
};

//# sourceMappingURL=data:application/json;charset=utf-8;base64,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
